<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('师傅提现.用户ID')">
                <a-input v-model="queryParam.userId" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('师傅提现.用户ID')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('师傅提现.审核状态')">
                <a-select :placeholder="$t('通用.输入.请选择')+$t('师傅提现.审核状态')" v-model="queryParam.status" allowClear>
                  <a-select-option :value="0">{{$t('师傅提现.未审核')}}</a-select-option>
                  <a-select-option :value="1">{{$t('师傅提现.审核未通过')}}</a-select-option>
                  <a-select-option :value="2">{{$t('师傅提现.审核已通过')}}</a-select-option>
                  <a-select-option :value="3">{{$t('师傅提现.转账中')}}</a-select-option>
                  <a-select-option :value="4">{{$t('师傅提现.已转账')}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('师傅提现.提现方式')">
                <a-select :placeholder="$t('通用.输入.请选择')+$t('师傅提现.提现方式')" v-model="queryParam.withdrawType" allowClear>
                  <a-select-option value="1">{{$t('师傅提现.支付宝')}}</a-select-option>
                  <a-select-option value="2">{{$t('师傅提现.微信')}}</a-select-option>
                  <a-select-option value="3">{{$t('师傅提现.银行卡')}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 操作 -->
      <div class="table-operations">
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>

      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="status" slot-scope="text, record">
          <span v-if="record.status == '0'" style="color: #1890ff">{{$t('师傅提现.未审核')}}</span>
          <span v-else-if="record.status == '1'" style="color: #f5222d">{{$t('师傅提现.审核未通过')}}</span>
          <span v-else-if="record.status == '2'" style="color: #52c41a">{{$t('师傅提现.审核已通过')}}</span>
          <span v-else-if="record.status == '3'" style="color: #faad14">{{$t('师傅提现.转账中')}}</span>
          <span v-else-if="record.status == '4'" style="color: #52c41a">{{$t('师傅提现.已转账')}}</span>
        </span>

        <span slot="withdrawType" slot-scope="text, record">
          <span v-if="record.withdrawType == '1'">{{$t('师傅提现.支付宝')}}</span>
          <span v-else-if="record.withdrawType == '2'">{{$t('师傅提现.微信')}}</span>
          <span v-else-if="record.withdrawType == '3'">{{$t('师傅提现.银行卡')}}</span>
        </span>

        <span slot="withdrawScene" slot-scope="text, record">
          <span v-if="record.withdrawScene == 1">{{$t('师傅提现.线上自动打款')}}</span>
          <span v-else-if="record.withdrawScene == 2">{{$t('师傅提现.线下手动打款')}}</span>
        </span>

        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>

        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-if="record.status == '0'" v-hasPermi="['homeworker:withdraw:edit']">
            <a-icon type="edit" />{{$t('通用.按钮.审核')}}
          </a>
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-else v-hasPermi="['homeworker:withdraw:query']">
            <a-icon type="eye" />{{$t('通用.按钮.详情')}}
          </a>
        </span>
      </a-table>

      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => $t('通用.文本.共')+total+$t('通用.文本.条')"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageHomeWorkerWithdraw } from '@/api/homeworker/withdraw'
import { tableMixin } from '@/store/table-mixin'
import CreateForm from './modules/CreateForm'

export default {
  name: 'HomeWorkerWithdraw',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      selectedRowKeys: [],
      selectedRows: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        userId: undefined,
        status: undefined,
        withdrawType: undefined,
        withdrawScene: undefined,
        accountNum: undefined,
        accountName: undefined,
        orderNo: undefined,
        failureReason: undefined,
        auditOpinion: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('师傅提现.用户ID'),
          dataIndex: 'userId',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('师傅提现.师傅信息'),
          dataIndex: 'nickName',
          ellipsis: true,
          align: 'center',
          customRender: function(text, record) {
            return (text || '-') + ' / ' + (record.mobile || '-')
          }
        },
        {
          title: this.$t('师傅提现.提现金额'),
          dataIndex: 'money',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('师傅提现.审核状态'),
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: 'status'}
        },
        {
          title: this.$t('师傅提现.提现账号'),
          dataIndex: 'accountNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('师傅提现.提现账号姓名'),
          dataIndex: 'accountName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('师傅提现.提现方式'),
          dataIndex: 'withdrawType',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: 'withdrawType'}
        },
        {
          title: this.$t('师傅提现.提现场景'),
          dataIndex: 'withdrawScene',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: 'withdrawScene'}
        },
        {
          title: this.$t('师傅提现.创建时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          width: '12%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  created () {
    this.getList()
  },
  methods: {
    /** 查询师傅端提现列表 */
    getList () {
      this.loading = true
      pageHomeWorkerWithdraw(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        status: undefined,
        withdrawType: undefined,
        withdrawScene: undefined,
        accountNum: undefined,
        accountName: undefined,
        orderNo: undefined,
        failureReason: undefined,
        auditOpinion: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      if (sorter.order) {
        this.queryParam.sortField = sorter.columnKey
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = ''
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    }
  }
}
</script>
